import { Flex } from '@revenuemarket/cds';

import useGetIntegratedScrapeStatus from '~hooks/queries/scraping/useGetIntegratedScrapeStatus';
import { useCompanyId } from '~hooks/useCompanyId';
import useIsDemoTrial from '~hooks/useIsDemoTrial';

import CollectionStatusText from '../CollectionStatusText';
import ScrapeBtn from '../ScrapeBtn';

const ScrapeSection = () => {
  const { companyId } = useCompanyId();

  const { data: scrapeStatusData } = useGetIntegratedScrapeStatus(companyId as string);
  const scrapeStatus = scrapeStatusData?.Data?.data;
  const isDemoTrial = useIsDemoTrial();
  if (!companyId || isDemoTrial) {
    return null;
  }
  return (
    <Flex align="center" justify="space-between">
      <CollectionStatusText
        status={scrapeStatus?.overallStatus}
        scrapeTime={scrapeStatus?.lastRequestedAt}
      />
      <ScrapeBtn />
    </Flex>
  );
};

export default ScrapeSection;
